import Vue from 'vue'
import VueRouter from 'vue-router'
import routeList from './routes'
import {isMobile} from '@/libs/user_utils'
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  const original = originalPush.call(this, location)
  return original && original.catch(err => err)
}
Vue.use(VueRouter)

const routes = routeList

const router = new VueRouter({
  mode:'history',
  routes
})

router.beforeEach((to, from, next) => {
  if (isMobile) {
    if(to.path.indexOf('mobile') === -1){
      location.replace('/mobile'+ to.fullPath)
    }else{
      next()
    }
  }else{
    next()
  }
})
router.afterEach(to => {
  const metaTitle = to?.meta?.title ?? ''
  window.document.title = `大玩家 ${metaTitle}`
 
  window.scrollTo(0, 0)
})

export default router
